import { Component, Input,EventEmitter, Output } from '@angular/core';
@Component({
  selector: 'dskl-button',
  template: `
  <button *ngIf="active" type="button" [style.padding]="xs?'1 1 1 1':''"  [style.background]="selected?(color?color:'#eaeaea'):''" [ngClass]="{'btn':true, 'btn-default':true,'btn-xs':small }" 
  
  (click)='onClick($event)'>
        <span [class]='classes()' aria-hidden="true"></span> {{text}}
    </button>
  `
})
//
export class ButtonComponent { 
   
  
    classes(){
        //if (!this.icon)return "";
        return "glyphicon "+this.icon;
    }
    @Input() active =true;
    @Input() small = false
    @Input() selectedOnClick = false;
    @Input() icon;
    @Output() clicked=new EventEmitter();
    @Input() text="";
    @Input() color;
    @Input() selected = false;
    @Input() xs=false;
    @Input() loadingText="Loading...";
   
    
    clickacble = true;
    onClick(e){
        if (!this.clickacble){
            console.log("Button is not clickable right now");
            return;
        }
        if (this.selectedOnClick){
            this.selected = !this.selected;
        }
        this.clicked.next(e);
    }
    beforeLoadingText;
    loading(){
        this.clickacble = false;
        this.beforeLoadingText = this.text;
        this.text= this.loadingText;
    }
    reset(){
        this.clickacble = true;
        this.text = this.beforeLoadingText;
    }
}



// WEBPACK FOOTER //
// /app/src/app/utils/button/button.component.ts